import { useUpdatePersonPrivateInfo } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { PersonNotesFormValuesType } from '../usePersonNotesSchema';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_PERSON_NOTES';

type UseUpdatePersonNotesReturnType = {
  updatePersonNotes: (formData: PersonNotesFormValuesType) => Promise<void>;
};

export const useUpdatePersonNotes = (
  personId: string
): UseUpdatePersonNotesReturnType => {
  const { showError, showSuccess } = useNotification();
  const { mutateAsync } = useUpdatePersonPrivateInfo();

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const updatePersonNotes = async (formData: PersonNotesFormValuesType) => {
    await mutateAsync(
      {
        id: personId,
        data: { notes: formData.notes || null },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updatePersonNotes };
};
